// extracted by mini-css-extract-plugin
module.exports = {"logo":"b429494557--logo--GskWn","img":"b429494557--img--xX7yr","title":"b429494557--title--dTGfn","builder":"b429494557--builder--Cveyh"};